import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"com-pc-card rw-txt"},[_c(VCol,{staticClass:"com-pc-card-header rw-header"},[_c('span',{staticClass:"com-pc-card-title"},[_vm._v("発表文")])]),_c(VCol,{staticClass:"white box-link"},[(_vm.selectedRwDetailRw)?_c(VRow,{staticClass:"pl-4 pr-2"},[_c('span',{staticClass:"rw-span-text",domProps:{"textContent":_vm._s(_vm.selectedRwDetailRw.text)}})]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }